var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}},[_c('v-progress-circular',{attrs:{"data-cy":"loadingDialog","indeterminate":"","size":"100","width":"13","color":"accent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }